import * as React from 'react';

export enum ModalOutcome {
    DISMISS,
    VALIDATE,
}

export interface Props {
    children?: JSX.Element;
    onClose: (outcome: ModalOutcome) => void;
    title: string;
    show?: boolean;
}

interface State {
}

export class ValidationModal extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
        };
    }

    render() {
        var backdrop: JSX.Element | undefined = undefined;
        if (this.props.show === true || this.props.show === undefined) {
            backdrop = (
                <div
                    className="modal-backdrop fade show"
                    style={{ display: 'block', opacity: 0.5 }}
                />
            );
        }

        return (
            <div>
                <div
                    className={'modal fade ' + (this.props.show ? 'show' : '')}
                    id="exampleModal"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                    style={this.props.show ? { display: 'block' } : {}}
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            {this.renderHeader()}
                            {this.renderBody()}
                            {this.renderFooter()}
                        </div>
                    </div>
                </div>
                {backdrop}
            </div>
        );
    }

    private renderHeader(): JSX.Element {
        return (
            <div className="modal-header">
                <h5
                    className="modal-title"
                    id="exampleModalLabel"
                >
                    {this.props.title}
                </h5>
                <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={() => { this.props.onClose(ModalOutcome.DISMISS); }}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        );
    }

    private renderBody(): JSX.Element | undefined {
        if (this.props.children !== undefined) {
            return (
                <div className="modal-body">
                    {this.props.children}
                </div>
            );
        }
        return (undefined);
    }

    private renderFooter(): JSX.Element {
        return (
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => { this.props.onClose(ModalOutcome.DISMISS); }}
                >
                    Annuler
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => { this.props.onClose(ModalOutcome.VALIDATE); }}
                >
                    Valider
                </button>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/Modal/ValidationModal.tsx